import React, { useRef } from 'react';
import Diamond from '@uber/base-icons/diamond-filled';
import { useStyletron } from 'baseui';
import { useAtomValue, useSetAtom } from 'jotai';
import { useAPIProvider } from '../../../../common/hooks/use-api-provider';
import { annotationIdToLabelMapAtom, annotationMetadataAtom } from '../../atoms/annotation-atoms';
import { frameImageUrlsAtom } from '../../atoms/frame-image-urls-atom';
import { dispatchAtom } from '../../atoms/label-store-dispatch/dispatch';
import { EVENTS } from '../../atoms/label-store-dispatch/events';
import { currentFrameAtom } from '../../atoms/video-playback-atoms';
import { useThumbnailQueue } from '../../hooks/use-thumbnail-queue';
import { FrameThumbnail } from './frame-thumbnail';
export const VideoGrid = () => {
  const [css, theme] = useStyletron();
  const frameImageUrls = useAtomValue(frameImageUrlsAtom);
  const annotationMetadata = useAtomValue(annotationMetadataAtom);
  const annotationIdToLabelMap = useAtomValue(annotationIdToLabelMapAtom);
  const currentFrame = useAtomValue(currentFrameAtom);
  const dispatch = useSetAtom(dispatchAtom);
  const {
    videoFrameProcessor
  } = useAPIProvider();
  const {
    enqueueFrame
  } = useThumbnailQueue({
    videoFrameProcessor
  });
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const handleFrameClick = (frameIndex: number) => {
    dispatch({
      type: EVENTS.SET_CURRENT_FRAME,
      frameId: frameIndex
    });
  };
  const getAnnotationsInFrame = (frameIndex: number) => {
    const annotationsInFrame = [...annotationMetadata.entries()].filter(([, m]) => m.spans.some(span => span.start <= frameIndex && frameIndex <= span.end));
    if (annotationsInFrame.length === 0) {
      return null;
    }
    return <div className={css({
      position: 'absolute',
      bottom: theme.sizing.scale600,
      right: theme.sizing.scale600,
      background: `${theme.colors.backgroundSecondary}99`,
      borderRadius: theme.borders.radius300,
      padding: theme.sizing.scale100,
      display: 'flex',
      gap: theme.sizing.scale200
    })}>
        {annotationsInFrame.map(([id]) => {
        const label = annotationIdToLabelMap.get(id);
        if (!label) {
          return null;
        }
        return <Diamond key={id} color={label.style.fillColor} stroke={label.style.strokeColor} />;
      })}
      </div>;
  };
  return <div ref={scrollContainerRef} className={css({
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    backgroundColor: theme.colors.backgroundSecondary
  })}>
      {frameImageUrls.map((imageUrl, index) => <FrameThumbnail key={`frame-${index}`} imageUrl={imageUrl} frameIndex={index} currentFrame={currentFrame} onFrameClick={handleFrameClick} onFrameVisible={enqueueFrame} getAnnotationsInFrame={getAnnotationsInFrame} scrollContainerRef={scrollContainerRef} css={css} theme={theme} />)}
    </div>;
};